import React from 'react';
import './../App.css';
import BlueTicket from '../Components/BlueTicket';
import Search from '../Components/Search';
import Article from '../Components/Article';
import Editor from '../Components/Editor';
import SideBar from '../Components/SideBar';
import methodsOneContext from '../Contexts/MethodsOne';
import GoodsContainer from '../Components/GoodsContainer'
import PartialSite1 from '../Components/PartialSite1';
import ScrollAnimation from 'react-animate-on-scroll';


export default class App extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props.history.location.pathname);
  }

  state = {
    detailList: [],
    editId: -1
  }

  setDetailList(data) {

    this.setState(prevState => {
      return {
        detailList: data,
        editId: -1
      }
    })

  }

  editDetail(id) {
    this.setState(prevState => {
      return {
        editId: id
      }
    })
  }

  newEvent() {
    this.setState(prevState => {
      return {
        detailList: [{ Id: 0, Description: '', Tag: '' }],
        editId: 0
      }
    })

    console.log('رسsadadsadیدم');
    console.log(this.state);
    console.log(this.state.detailList);

  }

  render() {
    let detailList = this.state.detailList;
    let editId = this.state.editId;
    return (

      <>
        <div class="header_section maz-force-white">
        {/* <ScrollAnimation animateIn="fadeIn">
        
          </ScrollAnimation> */}
                 <ScrollAnimation animateIn="fadeIn">
            <PartialSite1 />
          <div class="animate-container">
         
            <div class="maz-description-main-container2">
              {/* <div class="uk-grid uk-scrollspy-init-inview uk-scrollspy-inview uk-animation-fade" data-uk-grid-margin="" data-uk-scrollspy="{cls:'uk-animation-fade',repeat:true}"> */}
              <div class="maz-description-bottom">


                <h2 class="h"><span >طراحی و تولید نرم افزار</span></h2>

           

                <p><span ><span>یکی از توانایی های ما تحلیل سیستم ها و تولید نرم افزارهایی،
                   منطبق بر روال ها و نیازهای شماست. با توجه به توسعه روز افزون فناوری اطلاعات در تمامی فعالیت های روزمره مردم
                  ، پیوستن به دنیای تکنولوژی و فناوری اطلاعات بخش جدایی ناپذیر از یک فعالیت تجاری موفق است. مدیریت اطلاعات و
                   اسناد، گردش اطلاعات، ارتباط با مشتریان و مصرف کنندگان، اطلاع رسانی، زمانبندی، گزارش گیری، نمودارهای آماری
                   و... علاوه بر مدیریت بهتر فعالیت اقتصادی و مجموعه شما، به کاهش هزینه ها کمک خواهد کرد و با افزایش کیفیتِ 
                  ارائه خدمات، موجب رضایت مندی مشتری خواهد شد. ما در این راه همراه شما خواهیم بود و با تحلیل دقیق
                   فعالیت های شما سامانه ای کارآمد و منطبق بر نیازهای شما طراحی و پیاده سازی و پشتیبانی خواهیم کرد.</span></span></p>
              </div>
              <div class="maz-description-top">
                <img width="868" height="276" src={require('./../img/custom-app-development.png')} alt="" />
              </div>
              {/* </div> */}
            </div>
            </div>
    
          </ScrollAnimation>
    
          <ScrollAnimation animateIn="fadeIn">
            <div class="maz-description-main-container">
              {/* <div class="uk-grid uk-scrollspy-init-inview uk-scrollspy-inview uk-animation-fade" data-uk-grid-margin="" data-uk-scrollspy="{cls:'uk-animation-fade',repeat:true}"> */}
              <div class="maz-description-right">


                <h2 class="h"><span >همکاری در تولید نرم افزار</span></h2>

                <p ><span ><span >گروه نرم افزاری بیت کالا همواره از پیشنهادات و ایده های خوب شما استقبال کرده و زمینه همکاری را جهت تولید نرم افزار فراهم خواهد کرد. ایده های خود را با ما درمیان بگذارید، ما همراه با کارشناسانمان درکنار شما خواهیم بود تا با بهره گیری از آخرین تکنولوژی های روز همکاری خود را آغاز کرده و ایده های شما را به حقیقت تبدیل کنیم.</span></span></p>

                <p><span ><span>امروزه نرم افزار بخش جدا نشدنی از هر کسب و کاریست. با توسعه کسب و کار، مدیریت آن سخت و پرهزیه شده و نیاز به وجود سیستم های نرم افزاری جهت افزایش سرعت، دقت و کاهش هزینه ها احساس می شود. اگر نرم افزار مناسبی برای کسب و کار خود پیدا نکردید به ما مراجعه کنید تا با همکاری هم راه حلی برای تولید نرم افزار مورد نیاز بیابیم.</span></span></p>
              </div>
              <div class="maz-description-left">
                <img width="560" height="310" src={require('./../img/slicica-01.jpg')} alt="" />
              </div>
              {/* </div> */}
            </div>
          </ScrollAnimation>
          <div class="animate-container2">
          <ScrollAnimation animateIn="fadeIn">
            <div class="maz-description-main-container">
              {/* <div class="uk-grid uk-scrollspy-init-inview uk-scrollspy-inview uk-animation-fade" data-uk-grid-margin="" data-uk-scrollspy="{cls:'uk-animation-fade',repeat:true}"> */}

              <div class="maz-description-right2">
                <img width="367" height="312" src={require('./../img/Solution.png')} alt="" />
              </div>
              <div class="maz-description-left2">
                <h2 class="h" style={{textAlign:"right"}}>
                  <span >تحلیل و ارائه راهکار های سازمانی و شرکتی</span>
                </h2>

                <p >
                  <span >
                    <span >یکی از اهداف اصلی ما تولید نرم افزاری ست که نیاز های شما را پوشش، و به بهبود فرآیندهای سازمان و یا شرکت شما کمک کند. از این رو تحلیل و ارائه راهکار مناسب از اهمیت بالایی برخوردار است. گام اولیه برای ارائه یک راهکار مناسب، تحلیل دقیق، شناخت کامل روال ها، نحوه ی گردش اطلاعات و ارتباطات شما می باشد. از این رو کارشناسان ما با حضور فیزیکی در محل کار شما به فعالیت هایی از قبیل: بررسی ساختار سازمانی، مشاهده روند کار و گردش اطلاعات، برگزاری جلسات تحلیل خواهند پرداخت و در نهایت این فعالیت ها موجب جمع آوری مستنداتی خواهد شد که پس از پالایش به طرح اولیه تولید نرم افزار تبدیل می شود</span>
                  </span>
                </p>
              </div>
              {/* </div> */}
            </div>
          </ScrollAnimation>
          </div>
        
        </div>
        {/* <GoodsContainer /> */}

      </>
    )
  }
}


